import { useEffect, useState } from "react";
import confetti from "canvas-confetti";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { BadgeShareDialog } from "@/components/BadgeShareDialog";
import { tourKey } from "@/components/WelcomeTour";

const burst = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const colors = ["#7C5CBF", "#F28FAD", "#FFE066", "#6BBF59", "#6CC3D5"];
  confetti({ particleCount: 70, spread: 75, startVelocity: 32, gravity: 0.8, scalar: 0.9, ticks: 180, origin: { y: 0.35 }, colors, zIndex: 40 });
  setTimeout(() => confetti({ particleCount: 40, spread: 100, startVelocity: 22, gravity: 0.7, scalar: 0.8, ticks: 160, origin: { y: 0.3 }, colors, zIndex: 40 }), 350);
};

// One gentle celebration per newly earned Skill of the Day badge
export const BadgeCelebration = ({ userId }) => {
  const [b, setB] = useState(null);
  const [sharing, setSharing] = useState(false);
  const [ready, setReady] = useState(() => !!localStorage.getItem(tourKey(userId)));
  useEffect(() => {
    if (ready) return undefined;
    const t = setInterval(() => localStorage.getItem(tourKey(userId)) && setReady(true), 1000);
    return () => clearInterval(t);
  }, [ready, userId]);
  useEffect(() => {
    if (!ready) return;
    api.get("/skill-badges/celebrate").then((r) => {
      const badge = r.data.badge;
      if (!badge) return;
      setB(badge); burst();
      api.post(`/skill-badges/celebrate/${badge.id}`).catch((e) => logError("Celebrate mark failed:", e));
    }).catch((e) => logError("Celebrate load failed:", e));
  }, [ready]);
  if (!b) return null;
  return (
    <section className="mm-card p-5 mt-6 mm-fade-up flex items-center gap-4" style={{ borderColor: b.color }} data-testid="badge-celebration">
      <div className="w-14 h-14 shrink-0 rounded-full flex items-center justify-center text-3xl" style={{ background: `${b.color}22` }} aria-hidden>{b.icon}</div>
      <div className="flex-1 min-w-0">
        <div className="text-xs font-bold uppercase tracking-wider text-mm-primary">New badge</div>
        <h3 className="font-bold text-lg" data-testid="badge-celebration-title">You earned {b.name} {b.icon}</h3>
        <p className="text-sm text-mm-muted">{b.description}. Small steps, every day. That's something to be proud of.</p>
        <button onClick={() => setSharing(true)} className="mm-btn !py-2 !px-4 text-sm mt-3" data-testid="badge-celebration-share">Share</button>
      </div>
      <button onClick={() => setB(null)} className="self-start text-mm-muted hover:text-mm-text" aria-label="Close" data-testid="badge-celebration-close"><X size={18} /></button>
      {sharing && <BadgeShareDialog badge={{ ...b, earned: true }} onClose={() => setSharing(false)} />}
    </section>
  );
};
